<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.act_type.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="act_type.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="act_type"
        :content_rich_text="act_type.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(act_type, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="act_type"
          :Text="act_type.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.act_type.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="isNaN(this.act_type.id)"
      :label="$t('reusable.common.isInstitutional')"
      label-for="input-is-institutional"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-checkbox
        id="input-is-institutional"
        v-model="act_type.is_institutional"
        size="sm"
        class="checkbox-centered"
      ></b-form-checkbox>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.act_type.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="act_type"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.act_type.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteActType"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
// import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "ActTypeForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    actType: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          school: "",
          active: true,
          is_institutional: false,
          created_by: null,
          creation_date: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    institution_id: {
      type: Number,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      act_type: this.actType
        ? {
            id: this.actType.id,
            name: this.actType.name,
            description: this.actType.description,
            is_institutional: this.actType.is_institutional,
            creation_date: this.actType.creation_date,
            created_by: this.actType.created_by,
            updated_by: this.actType.updated_by,
            update_date: this.actType.update_date,
          }
        : {
            id: generateUniqueId(),
            name: "",
            description: "",
            is_institutional: false,
          },
    };
  },
  validations: {
    act_type: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {
        // required,
        // minLength: minLength(5),
      },
    },
  },
  created() {},
  methods: {
    patchDescription(object, text) {
      this.act_type.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.act_type[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.act_type.$touch();
      if (this.$v.act_type.$anyError) {
        return;
      }
      if (isNaN(this.act_type.id)) {
        this.createActType();
      } else this.updateActType();
    },
    createActType() {
      this.act_type.school = this.institution_id;
      this.$restful.Post("/cideu/act-type/", this.act_type).then((response) => {
        toast(
          this.$t("reusable.common.created", {
            entity: this.$getVisibleNames(
              "cideu.acttype",
              false,
              "Tipo de Acta"
            ),
          })
        );
        this.$emit("created", response);
      });
    },
    updateActType() {
      this.act_type.school = this.institution_id;
      this.$restful
        .Put(`/cideu/act-type/${this.act_type.id}/`, this.act_type)
        .then((response) => {
          toast(
            this.$t("reusable.common.updated", {
              entity: this.$getVisibleNames(
                "cideu.acttype",
                false,
                "Tipo de Acta"
              ),
            })
          );
          this.$emit("updated", response);
        });
    },
    deleteActType() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("cideu.acttype", false, "Tipo de Acta"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(`/cideu/act-type/${this.act_type.id}/`)
            .then(() => {
              this.$emit("deleted", this.act_type);
            });
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.checkbox-centered {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
</style>